import React from "react";

export default function INTJ(props) {
  return (
    <div className="row">
      <div className="col-12 p-5">
        <article className="main description">
          <h1>شخصیت “معمار”</h1>
          <p>
            معماران به &zwnj; تنهایی در نوک قله قرار گرفته &zwnj;اند و یکی از
            کمیاب &zwnj;ترین و توانمندترین گونه &zwnj;های شخصیتی از حیث توانایی
            &zwnj;های استراتژیک هستند و به&zwnj;خوبی از این امر آگاهند. معماران
            تنها دو درصد جمعیت را تشکیل می&zwnj; دهند و زنان این گونه شخصیتی
            بسیار نادر هستند و فقط 0.8% جمعیت را تشکیل می&zwnj; دهند - به همین
            دلیل اغلب اوقات پیدا کردن افراد همفکر که قادر باشند با روشن&zwnj;
            اندیشی بی حد و حصر و مانورهای شطرنج&zwnj; وار آنها برابری کنند کار
            دشواری است. افراد دارای گونه شخصیتی معمار اهل تخیل و در عین حال
            قاطع، بلندپرواز و در عین حال گوشه&zwnj; گیر و به شکلی شگفت&zwnj; آور
            کنجکاو هستند، اما انرژی خود را بیهوده هدر نمی&zwnj; دهند.
          </p>{" "}
          <h2>
            هیچ چیز نمی&zwnj; تواند منش و رویکرد صحیح را از دستیابی به اهدافش
            بازدارد
          </h2>{" "}
          <p>
            معماران به دلیل تشنگی ذاتی&zwnj; شان برای کسب دانش که خود را در
            اوایل زندگی نشان می&zwnj; دهد، اغلب کودکانی "خرخوان" لقب داده
            می&zwnj; شوند. اگرچه ممکن است این لقب از نظر همسالان نوعی توهین تلقی
            شود، اما آنها به احتمال زیاد با آن همدلی کرده و حتی به آن افتخار
            می&zwnj; کنند و از مجموعه گسترده و عمیق دانش خود بهره می&zwnj; برند.
            معماران همچنین از اینکه آنچه را می&zwnj; دانند به دیگران بگویند لذت
            می&zwnj; برند، از تسلط خود به موضوعات مورد انتخابشان مطمئن هستند،
            اما این شخصیت&zwnj; ها ترجیح می&zwnj; دهند به طراحی و اجرای طرحی
            درخشان در حوزه کاری خود بپردازند تا اینکه دیدگاه&zwnj; هایی در مورد
            مسائل فرعی "غیرجذاب" همچون شایعات را بپذیرند.
          </p>{" "}
          <blockquote>
            <p>
              شما حقی نسبت به دیدگاه خودتان ندارد. شما فقط در مورد دیدگاه
              آگاهانه خود محق هستید. هیچ کس حق ندارد نادان باشد.
            </p>{" "}
            <footer>Harlan Ellison</footer>
          </blockquote>{" "}
          <p>
            پارادوکس آنها از دید اکثر ناظران این است که معماران می&zwnj; توانند
            با تناقض&zwnj; هایی آشکار به زندگی بپردازند - حداقل از دیدگاه صرفاً
            منطقی. به&zwnj; عنوان مثال، معماران همزمان هم رؤیاپردازترین
            آرمانگرایان و هم بدبین&zwnj; ترین بدبینان هستند، تعارضی که به ظاهر
            غیرممکن است. اما دلیل این امر آن است که افراد دارای گونه شخصیتی
            معمار باور دارند که با تلاش، هوش و ملاحظه، هیچ چیز غیرممکن است، در
            عین حال که معتقدند مردم خیلی تنبل، کوته&zwnj; بین یا خودخواه هستند و
            نمی&zwnj; توانند به این نتایج فوق&zwnj; العاده دست یابند. در عین حال
            چنین دیدگاه بدبینانه&zwnj; ای نسبت به واقعیت، مانع از آن نخواهد شد
            که معمار علاقه&zwnj; مند از دستیابی به نتیجه&zwnj; ای که به آن باور
            دارد دست بکشد.
          </p>
          <h2>در مسائل مربوط به اصول، همچون کوه ایستادگی کن</h2>{" "}
          <p>
            معماران اعتماد به نفس و هاله&zwnj; ای از رمز و راز از خود می&zwnj;
            پراکنند و مشاهدات روشنگر، ایده&zwnj; های اصیل و منطق توانمندشان آنها
            را قادر می&zwnj; سازد تنها با اراده مطلق و نیروی شخصیت خود تغییر
            ایجاد کنند. گاهی اوقات چنین به نظر می&zwnj; رسد که معماران دست به
            شالوده&zwnj; شکنی و بازسازی هر ایده و نظامی می&zwnj; زنند که با آن
            برخورد می&zwnj; کنند و در این زمینه حس کمال&zwnj; گرایی و حتی اخلاق
            را به کار می&zwnj; بندند. هر کسی که استعداد آن را نداشته باشد که با
            فرآیندهای معماران برابری کند یا بدتر از آن، متوجه منظورشان نشود به
            احتمال زیاد فوراً و برای همیشه احترام خود را از دست خواهد داد.
          </p>{" "}
          <blockquote className="no-footer">
            <p>
              قوانین، محدودیت&zwnj; ها و سنت&zwnj; ها مورد نفرت گونه شخصیتی
              معمار هستند - همه چیز باید در معرض پرسش و ارزیابی مجدد قرار گیرد و
              اگر معماران راهی پیدا کنند، اغلب یک&zwnj; جانبه دست به کار
              می&zwnj; شوند و ایده&zwnj; ها و روش&zwnj; های خود را که از لحاظ
              فنی برتر، غیرمعمول و گاهی اوقات بی&zwnj; رحمانه و تقریباً همیشه
              غیرسنتی هستند را به اجرا می&zwnj; گذارند.
            </p>
          </blockquote>{" "}
          <p>
            این مسئله را نباید به اشتباه تکانشگری دانست - معماران همواره
            می&zwnj; کوشند منطقی بمانند و مهم نیست که هدف نهایی تا چه اندازه
            جذاب باشد، و هر ایده، چه در درون خود فرد تولید شده باشد یا از جهان
            خارج گرفته شده باشد، باید از فیلتر بی&zwnj; رحمانه و همیشه حاضر "آیا
            واقعاً مؤثر است؟" بگذرد. این سازوکار همواره، در مورد همه چیز و همه
            کس اعمال می&zwnj; شود و اغلب همین&zwnj; جا است که گونه شخصیتی معمار
            دچار مشکل می&zwnj; شود.
          </p>{" "}
          <h2>کسی که به تنهایی سفر می&zwnj; کند بیشتر تأمل می&zwnj; کند</h2>
          <p>
            معماران باهوش هستند و به دانشی که برای فراگیری آن زمان صرف
            کرده&zwnj; اند مطمئن هستند، اما متأسفانه بعید است قرارداد اجتماعی
            جزو چنین موضوعاتی باشد. شاید دروغ مصلحتی و صحبت&zwnj; های کوچک برای
            گونه شخصیتی که مشتاق حقیقت و عمق است دشوار باشد، اما ممکن است
            معماران تا آنجا پیش بروند که بسیاری از قراردادهای اجتماعی را کاملاً
            احمقانه بدانند. از قضا، بهتر است معماران در جایی بمانند که در آن
            راحت هستند - یعنی خارج از کانون توجه - که در آنجا اعتماد به نفس
            طبیعی در بین معماران رواج دارد، اما وقتی با افراد آشنا همکاری
            می&zwnj; کنند چراغ راه آنها می&zwnj; شوند و موجب جذب افراد با خلق و
            خو و علایق مشابه می&zwnj; گردند - که این جذب می&zwnj; تواند جنبه
            عاشقانه یا شکل دیگری داشته باشد.
          </p>{" "}
          <p>
            معماران با تمایل خود برای حرکت در مسیر زندگی همچون صفحه شطرنجی بزرگ
            تعریف می&zwnj; شوند، جایی که مهره&zwnj; ها به طور مداوم با هوش و
            ملاحظه جابجا می&zwnj; کنند، همواره تاکتیک&zwnj; ها و استراتژی&zwnj;
            های جدید و برنامه&zwnj; های احتیاطی ارزیابی می&zwnj; نمایند،
            به&zwnj; طور مداوم همتایان خود را وادار به جابجایی می&zwnj; کنند تا
            کنترل وضعیت را حفظ کرده و در عین حال آزادی حرکت خود را به حداکثر
            برسانند. این بدان معنی نیست که معماران بدون توجه به ندای وجدان عمل
            می&zwnj; کنند، اما از نظر بسیاری از گونه&zwnj; های دیگر، تنفر معمار
            از اقدام بر اساس احساسات چنین چیزی را به ذهن متبادر می&zwnj; کند، و
            همچنین توضیح می&zwnj; دهد که چرا بسیاری از افراد شرور در
            داستان&zwnj; ها (و قهرمانانی که در موردشان سوءتفاهم شده است) بر اساس
            این گونه شخصیتی ساخته می&zwnj; شوند.
          </p>
        </article>
      </div>
    </div>
  );
}
